import { render } from "./MyInput.vue?vue&type=template&id=2f852942&scoped=true&ts=true"
import script from "./MyInput.vue?vue&type=script&lang=ts"
export * from "./MyInput.vue?vue&type=script&lang=ts"

import "./MyInput.vue?vue&type=style&index=0&id=2f852942&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f852942"]])

export default __exports__